import React from 'react'
import Countdown from 'react-countdown';
import './Styles/Third.css'
import logo from '../logo.png'

export default function Third() {

  const Completionist = () => <span>You are good to go!</span>;

  return (
    <div className='third'>
       <div className='timer'>6 June 2022</div>
      <div className='about'>
        <div className='atitle'>About PSNACET</div>
        <div className='adesc'>Affiliated to Anna University, Chennai, approved by AICTE, New Delhi, and accredited by the National Board of Accreditation (NBA), PSNA challenges the status quo and make discoveries that reshape the future. In a span of 38 years, it has emerged as one of the premier engineering colleges for sheer intellectual breadth and life-changing experience to advance knowledge. Home to more than six thousand five hundred students across the country as well as overseas, PSNA offers 9 undergraduate programmes and 7 postgraduate programmes in Engineering, Technology, Computer Applications and Management Studies, besides Doctoral Programmes in Engineering, Technology, and Science & Humanities through recognized Research Centres of the college by Anna University, Chennai, with world of opportunities to help one grow and transform amid varied options for internal exploration and self-discovery.</div>
      </div>
      <div className='logos'>
        <img src={logo} alt='logo'/>
      </div>
    </div>
  )
}
